import { v4 as uuidv4 } from 'uuid';
import { WorkflowStepPresenterModel } from './workflow-step-presenter.model';
import { LocalizedValue } from '@osos/shared/api';
import { Identified } from '../../base/identified.type';

export class DataEntityWorkflowPresenterModel implements Identified<string> {
  id: string;
  isDefault: boolean;
  name: LocalizedValue;
  steps: WorkflowStepPresenterModel[];
}
